"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuteFindingResponseProperties = void 0;
/**
 * Information about the mute status of this finding.
 */
class MuteFindingResponseProperties {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return MuteFindingResponseProperties.attributeTypeMap;
    }
}
exports.MuteFindingResponseProperties = MuteFindingResponseProperties;
/**
 * @ignore
 */
MuteFindingResponseProperties.attributeTypeMap = {
    description: {
        baseName: "description",
        type: "string",
    },
    expirationDate: {
        baseName: "expiration_date",
        type: "number",
        format: "int64",
    },
    muted: {
        baseName: "muted",
        type: "boolean",
    },
    reason: {
        baseName: "reason",
        type: "FindingMuteReason",
    },
};
//# sourceMappingURL=MuteFindingResponseProperties.js.map